import React from "react"

import Collapsible from "react-collapsible"
import { accordionUniqueId } from "@/utils/index"

import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/Bundles/localization"

import Feature from "@/components/Bundles/StaticBundle/BundlesAccordian/Feature"
import SpecsInstallation from "@/components/Bundles/StaticBundle/BundlesAccordian/SpecsInstallation"
import CollapsibleHeader from "@/components/Bundles/StaticBundle/BundlesAccordian/CollapsibleHeader"

import accordionStyles from "@/components/core/Accordion/Accordion.module.scss"
import Style from "@/components/Bundles/StaticBundle/BundlesAccordian/index.module.scss"
import { accordianClickBundleFeature } from "@/components/Bundles/analytics"

const BundlesAccordian = props => {
  const {
    parentSku,
    title = "",
    handleOpen = () => {},
    handleClose = () => {},
    isOpen = false,
    items = [],
  } = props

  const { t } = useTranslation("common")
  const { featuresLabel = "" } = getTranslations(t)

  const specsInstallData = {
    title,
    parentSku,
    isOpen,
    items,
    handleOpen,
    handleClose,
  }
  const handleOpenAccordian = (title = "") => {
    accordianClickBundleFeature(title.toLowerCase(), "expand")
  }
  const handleCloseAccordian = (title = "") => {
    accordianClickBundleFeature(title.toLowerCase(), "collapse")
  }

  const features = []
  items.forEach(e => {
    features.push(...e.productFeatures)
  })

  return (
    <div
      className={`${accordionStyles.accordionWrapper} ${Style.BundlesAccordianWrapper} container-fluid`}
    >
      {features.length ? (
        <div
          className="collapsible-accordion bundle-accordian-section"
          data-testid={`bundle-product-accordion-${title}`}
        >
          <Collapsible
            trigger={<CollapsibleHeader title={featuresLabel} />}
            onTriggerOpening={() => handleOpenAccordian(featuresLabel)}
            onTriggerClosing={() => handleCloseAccordian(featuresLabel)}
            triggerOpenedClassName="collapsible__trigger--open"
            open={isOpen}
            openedClassName="collapsible--open"
            transitionTime={400}
            tabIndex="0"
            easing="ease-in-out"
            triggerElementProps={{
              id: accordionUniqueId("collapsible-trigger", 9999, 1000),
            }}
            contentElementId={accordionUniqueId(
              "collapsible-content",
              9999,
              1000
            )}
          >
            <div
              className="row no-gutters px-0"
              data-testid={`colapse-data-${title}`}
              aria-disabled={isOpen}
            >
              {items.map(item =>
                item.productFeatures?.length ? (
                  <React.Fragment key={item.sku}>
                    <Feature data={item} />
                  </React.Fragment>
                ) : null
              )}
            </div>
          </Collapsible>
        </div>
      ) : null}

      <SpecsInstallation {...specsInstallData} />
    </div>
  )
}

export default BundlesAccordian
